import type { ReactNode } from "react";

/**
 * Cabeçalho editorial no padrão da landing page: display grande com tracking
 * negativo, eyebrow em caixa alta discreta e hairline `foreground/10`.
 */
export function PageHeader({
  eyebrow,
  title,
  subtitle,
  children,
  align = "left",
}: {
  eyebrow?: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  children?: ReactNode;
  align?: "left" | "center";
  /** @deprecated mantido para compatibilidade de chamadas antigas */
  eyebrowBadge?: boolean;
}) {
  const isCenter = align === "center";
  return (
    <header>
      <div
        className={
          isCenter
            ? "mx-auto max-w-3xl px-5 pb-6 pt-6 text-center md:px-6 md:pb-10 md:pt-14"
            : "mx-auto max-w-[1400px] px-4 pb-4 pt-5 lg:px-5 lg:pb-8 lg:pt-16"
        }
      >
        {eyebrow ? (
          <div className="mb-2 text-[10.5px] lg:mb-4 lg:text-[11px] font-semibold uppercase tracking-[0.22em] text-muted-foreground">
            {eyebrow}
          </div>
        ) : null}
        <h1 className="font-display text-[clamp(1.9rem,4vw,3.5rem)] font-semibold leading-[1.02] tracking-[-0.035em] text-foreground">
          {title}
        </h1>
        {subtitle ? (
          <p
            className={
              "mt-2 max-w-xl text-[13.5px] leading-[1.5] text-muted-foreground lg:mt-3 lg:text-[15px]" +
              (isCenter ? " mx-auto" : "")
            }
          >
            {subtitle}
          </p>
        ) : null}
        {children ? (
          <div className={"mt-4 flex flex-wrap items-center gap-2 lg:mt-6" + (isCenter ? " justify-center" : "")}>
            {children}
          </div>
        ) : null}
      </div>
    </header>
  );
}
